export default "__VITE_ASSET__ZRGan67L__"